import { BaseControl } from "@share/common/controls/base/base-control";
import { Component, Prop } from "vue-property-decorator";

@Component
/**
 * Class names holder for glass controls
 */
export class BaseGlass extends BaseControl {

  @Prop({ default: 'transparent' }) modificationName: string;
  @Prop() error: boolean;

  get baseClassName(): {[classname: string]: boolean} {
    return {
      'control-wrapper__control': true,
      'control-wrapper__control_glass': true,
      ['glass-control']: true,
      [this.errorClass]: this.error,
      ['glass-control_disabled']: this.disabled
    }
  }

  get iconClass() {
    return {
      ['glass-control__icon']: true,
      ['glass-control__icon_disabled']: this.disabled
    }
  }

  get errorClass() {
    return 'glass-control_error'
  }
}